// Module
var code = "<div id=\"V-ADD82F83-1C00-4F60-B0CF-3D4C449C692D\"> <div data-b-component=\"checkbox\" data-b-comp-checked=\"{Binding value}\"></div> </div> ";
// Exports
export default code;